import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

/** Toggleable chip used in single- and multi-select chip groups. */
@Component({
  selector: 'bb-chip',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <button
      type="button"
      [attr.aria-pressed]="active()"
      [attr.aria-disabled]="disabled() ? true : null"
      [disabled]="disabled()"
      (click)="onClick()"
      class="inline-flex select-none items-center gap-1.5 rounded-full border px-3.5 py-2 text-sm font-semibold transition-all"
      [class]="chipClass()">
      @if (active() && !disabled()) {
        <span aria-hidden="true" class="text-xs">✓</span>
      }
      <ng-content />
    </button>
  `,
})
export class BbChip {
  readonly active = input<boolean>(false);
  readonly disabled = input<boolean>(false);
  readonly toggled = output<void>();

  readonly chipClass = computed(() => {
    if (this.disabled()) {
      return 'cursor-not-allowed border-border bg-muted text-muted-foreground opacity-50';
    }
    return this.active()
      ? 'border-brand-studio bg-brand-studio text-white'
      : 'border-border bg-card text-foreground hover:border-foreground/30';
  });

  onClick(): void {
    if (this.disabled()) {
      return;
    }
    this.toggled.emit();
  }
}
